import axios, { AxiosResponse } from "axios";
import { QuestionReportDTO } from "../../models/dtos/exams/question-report/QuestionReportDTO";
import { QuestionReportEditionDTO } from "../../models/dtos/exams/question-report/QuestionReportEditionDTO";
import { QuestionReportInQueryDTO } from "../../models/dtos/exams/question-report/QuestionReportInQueryDTO";
import { QuestionReportInqueryQueryString } from "../../models/query-strings/exams/question-report/QuestionReportInqueryQueryString";
import BaseService from "../base/BaseService";

export default class QuestionReportService extends BaseService {
    create(dto: QuestionReportEditionDTO): Promise<any> {
        return axios.post('/QuestionReport', dto).then(function (response: AxiosResponse<any, any>) {
            return response;
        });
    }

    update(dto: QuestionReportEditionDTO): Promise<any> {
        return axios.put('/QuestionReport', dto).then(function (response: AxiosResponse<any, any>) {
            return response;
        });
    }

    hasQuestionReport(queryString: QuestionReportInqueryQueryString): Promise<QuestionReportInQueryDTO> {
        return axios.get('/QuestionReport/HasReport', { params: queryString }).then(function (response: AxiosResponse<QuestionReportInQueryDTO, any>) {
            return response.data;
        });
    }

    getQuestionByDetails(queryString: QuestionReportInqueryQueryString): Promise<QuestionReportDTO> {
        return axios.get('/QuestionReport/Details', { params: queryString }).then(function (response: AxiosResponse<QuestionReportDTO, any>) {
            return response.data;
        });
    }
}